export default {
  "BaseCard": "_BaseCard_zv41n_1",
  "Enabled": "_Enabled_zv41n_9",
  "Disabled": "_Disabled_zv41n_14",
  "EmptyCard": "_EmptyCard_zv41n_20",
  "EmptyCardTitle": "_EmptyCardTitle_zv41n_29",
  "EmptyCardDescription": "_EmptyCardDescription_zv41n_35",
  "FeatureFlagDisabledCard": "_FeatureFlagDisabledCard_zv41n_41"
};import "ni:sha-256;fbl6cOthXK9BJC3Jg6B_wQ8rvOmSEQYxodyKV4r1JBs";